import config from '@/common/config';

/**
 * Azure auth configuration.
 */
export default function getAzureAuthConfig(clientId, authority) {
  /**
   * Scopes you add here will be prompted for user consent during sign-in.
   * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
   * For more information about OIDC scopes, visit:
   * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
   */
  const loginRequest = {
    scopes: ['User.Read'],
  };

  /**
   * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
   */
  const tokenRequest = {
    scopes: ['User.Read'],
    forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
  };
  const msalConfig = {
    auth: {
      clientId,
      authority,
      redirectUri: `${config.webAppBaseUrl}`,
      postLogoutRedirectUri: config.webAppBaseUrl,
      navigateToLoginRequestUrl: false, //Navigate to page where MSAL login has been triggered
    },
    cache: {
      cacheLocation: 'sessionStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case 'Error':
              console.error(message);
              return;
            default:
              console.info(message);
              return;
          }
        },
      },
    },
  };
  return { loginRequest, tokenRequest, msalConfig };
}
